import Vue from "vue";
import Router from "vue-router";
import home from "./../components/home.vue";
import enter from "./../components/enter.vue";
import daolujiuyuan from "./../components/daolujiuyuan.vue";
import xiaofeijilu from "./../components/xiaofeijilu.vue";
import taocanxiangmu from "./../components/taocanxiangmu.vue";
import zaixianyuyue from "./../components/zaixianyuyue.vue";
import yuyuedingdan from "./../components/yuyuedingdan.vue"
import jifenshangcheng from "./../components/jifenshangcheng.vue";
import store from "./../components/store.vue";
import shiyongmendian from "./../components/shiyongmendian.vue";
import yuyue from "./../components/yuyue.vue";

import youhuiquan from "./../components/youhuiquan.vue";
import bandinfo from "./../components/bandinfo.vue";
import projectdetails from './../components/projectdetails.vue'
import wodeyuyue from './../components/wodeyuyue.vue'
import yuyuedetails from './../components/yuyuedetails.vue'
import demo from "../components/demo.vue";


import { getUrlCode, getHref } from "../util/index";
const vm = new Vue();

Vue.use(Router);

// const path = require('path')
// const files = require.context('@/components', false, /\.vue$/)
// console.log(files.keys())
const route = new Router({
  mode: "hash",
  routes: [
    { 
      path: "/", 
      name: "/", 
      component: home,
    },
    { path: "/index", name: "/index", component: home },
    { path: "/enter", name: "/enter", component: enter },
    { path: "/demo", name: "/demo", component: demo },
    {
      path: "/daolujiuyuan",
      name: "/daolujiuyuan",
      component: () => import("../components/daolujiuyuan.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/xiaofeijilu",
      name: "/xiaofeijilu",
      component: () => import("../components/xiaofeijilu.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/taocanxiangmu",
      name: "/taocanxiangmu",
      component: () => import("../components/taocanxiangmu.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/zaixianyuyue",
      name: "/zaixianyuyue",
      component: () => import("../components/zaixianyuyue.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/yuyuedingdan",
      name: "/yuyuedingdan",
      component: () => import("../components/yuyuedingdan.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/jifenshangcheng",
      name: "/jifenshangcheng",
      component: () => import("../components/jifenshangcheng.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/store",
      name: "/store",
      component: () => import("../components/store.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/shiyongmendian",
      name: "/shiyongmendian",
      component: () => import("../components/shiyongmendian.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/yuyue",
      name: "/yuyue",
      component: () => import("../components/yuyue.vue"),
      meta: {
        auth: true
      }
    },

    {
      path: "/youhuiquan",
      name: "/youhuiquan",
      component: () => import("../components/youhuiquan.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/bandinfo",
      name: "/bandinfo",
      component: () => import("../components/bandinfo.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: '/projectdetails', 
      name: '/projectdetails', 
      component: () => import('./../components/projectdetails.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/wodeyuyue', 
      name: '/wodeyuyue', 
      component: () => import('./../components/wodeyuyue.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/yuyuedetails', 
      name: '/yuyuedetails', 
      component: () => import('./../components/yuyuedetails.vue'),
      meta: {
        auth: true
      }
    },
    // {path: '/demo', name: '/demo', component: () => import('./../components/demo.vue')},

    {
      path: "/huiyuanka",
      name: "/huiyuanka",
      component: () => import("../components/huiyuanka.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/taocanzhifu",
      name: "/taocanzhifu",
      component: () => import("../components/taocanzhifu.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/huiyuanchongzhi",
      name: "/huiyuanchongzhi",
      component: () => import("../components/huiyuanchongzhi.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/marketingList",
      name: "/marketingList",
      component: () => import("../components/Marketing/index.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/marketing",
      name: "/marketing",
      component: () => import("../components/Marketing/marketing.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/storedetail",
      name: "/storedetail",
      component: () => import("../components/Storedetail.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/shareholder",
      name: "/shareholder",
      component: () => import("../components/shareholder.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/mymember",
      name: "/mymember",
      component: () => import("../components/shareholder/MyMember.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/gudongqrcode",
      name: "/gudongqrcode",
      component: () => import("../components/shareholder/gudongqrcode.vue"),
      meta: { auth: true }
    },
    {
      path: "/fenxiao",
      name: "/fenxiao",
      component: () => import("../components/shareholder/fenxiao.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/qrcode",
      name: "/qrcode",
      component: () => import("../components/shareholder/qrcode.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/fenhongjilu",
      name: "fenhongjilu",
      component: () => import("../components/shareholder/fenhongjilu.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/gubenxiaofei",
      name: "gubenxiaofei",
      component: () => import("../components/shareholder/gubenxiaofei.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/tixianjilu",
      name: "tixianjilu",
      component: () => import("../components/shareholder/tixianjilu.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/bind",
      name: "bind",
      component: () => import("../components/bind.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/nothing",
      name: "nothing",
      component: () => import("../components/nothing.vue"),
      meta: {
        auth: true
      }
    }
  ]
});

route.beforeEach((to, from, next) => {
  //from 是当前路由 to 是准备进入的路由
  let token = window.sessionStorage.getItem("token");

  let hid = getUrlCode('hid') || ''

  if(hid.length > 5) {
    hid = hid.split('?')[0]
  }
  
  sessionStorage.setItem("hid", hid);

  console.log(to.meta.auth);
  let auth = to.meta.auth;
  // 授权
  if (!token && auth) {
    let code = getUrlCode("code");
    if (!code) {
      //没code，获取appid然后再获取code，调用这个函数会回调当前页面并且带code
      vm.$api.getAppid(location.href);
    } else {
      vm.$api.login(code).then(res => {
        console.log("登录成功");
        if (res === 1) {
          let href = getHref("code", "state");
          window.location.href = href;
        }
      });
    }
    return;
  }

  next();
});

export default route;



// WEBPACK FOOTER //
// ./src/router/index.js